export type LogLevel = 'debug' | 'error' | 'info' | 'warn';

export abstract class Logger {
  abstract available(): boolean;
  abstract saveHttpLog<T>(error: T): void;
  abstract saveJsLog(error: Error, exception: string, level: LogLevel): void;
}
